import { Icon } from '@aibees/shared/components';
import { Box as BoxBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(BoxBase)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(1)};
`;

export const Box = styled(BoxBase)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CloseIcon = styled(Icon)`
  cursor: pointer;
`;
